import { ContactType_Enum } from '@weave/schema-gen-ts/dist/shared/persons/v3/enums.pb';

export type PERSON_PHONES_BY_TYPE = Exclude<ContactType_Enum, ContactType_Enum.UNSPECIFIED | ContactType_Enum.EMAIL>;

export const PERSON_PHONE_TYPES_ORDER: PERSON_PHONES_BY_TYPE[] = [
  ContactType_Enum.PHONE_MOBILE,
  ContactType_Enum.PHONE_HOME,
  ContactType_Enum.PHONE_WORK,
] as const;
